<p-confirmDialog />
<h3 class="with-manual-link">
  <span i18n="@@stage-manager">Stage-Manager</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Allgemein/Konfiguration/Stage-Manager"
  ></app-manual-link>
</h3>
<p
  class="text-secondary mt-1 mb-1"
  i18n="@@stage-manager-description"
>
  In diesem Tab kannst du Stages erstellen, um den Bot im Verlauf der Kommunikation in verschiedene Zustände zu
  versetzen und damit die Kommunikation und das Benutzererlebnis steuern zu können.
</p>
<div class="row">
  <div class="col-3">
    <span i18n="@@title">Titel</span>
  </div>
  <div class="col">
    <input
      #stageTitleInput
      pInputText
      type="text"
      class="w-100"
      i18n-placeholder="@@describe-stage-title"
      placeholder="Titel der Stage"
      [(ngModel)]="this.stageTitle"
      [ngModelOptions]="{updateOn: 'change'}"
      (keydown.enter)="this.stageTitle = stageTitleInput.value; this.createStage()"
    >
  </div>
</div>
<div class="row mt-2">
  <div class="col-3">
  </div>
  <div class="col">
    <p-button
      size="small"
      severity="primary"
      [disabled]="this.stageTitle.trim() === ''"
      icon="ri-add-line"
      (onClick)="this.createStage()"
      i18n-label="@@add-stage"
      label="Neue Stage erstellen"
    ></p-button>
  </div>
</div>
@if (this.stageAdmin.stages.length > 0) {
<h5
  class="mt-5"
  i18n="@@stages-overview"
>Stages im Überblick</h5>
}
@if (bulkFailedNames) {
<p
  class="bot-bulk-error"
  role="alert"
><span i18n="@@stage-bulk-failed">Folgende Stages konnten nicht gelöscht werden. Versuche es erneut:</span>
  {{bulkFailedNames}}</p>
}
<p-table
  [value]="this.stageAdmin.stages"
  dataKey="_id"
  [(selection)]="selectedStages"
  [rowHover]="true"
  (onRowReorder)="this.onRowReorder()"
  styleClass="p-datatable-sm"
>
  <ng-template pTemplate="header">
    @if (this.stageAdmin.stages.length > 0) {
    <tr>
      <th style="width: 2.5rem;"></th>
      <th class="bot-selection-cell"><p-tableHeaderCheckbox
          [disabled]="bulkBusy"
          ariaLabel="Alle Stages auswählen"
          i18n-ariaLabel="@@stage-select-all"
        /></th>
      <th i18n="@@title">Titel</th>
      <th i18n="@@stage-name-indent">Identifikator</th>
      <th class="text-center">
        <span i18n="@@stage-position">Position</span>
        @if (this.positionsNeedNormalization) {
        <i
          class="ri-information-line text-muted ms-1"
          pTooltip="Wenn du eine Stage verschiebst, werden alle Positionen aktualisiert."
          i18n-pTooltip="@@stage-position-normalize-hint"
          tooltipPosition="top"
        ></i>
        }
      </th>
      <th i18n="@@actions">Aktionen</th>
    </tr>
    }
  </ng-template>
  <ng-template
    pTemplate="body"
    let-stage
    let-index="rowIndex"
  >
    <tr [pReorderableRow]="index">
      <td>
        <i
          class="ri-draggable drag-handle"
          pReorderableRowHandle
        ></i>
      </td>
      <td class="bot-selection-cell"><p-tableCheckbox
          [value]="stage"
          [disabled]="bulkBusy"
          [ariaLabel]="stage.title"
        /></td>
      <td>
        <span
          class="fakelink"
          (click)="this.showDetailDrawer(stage._id)"
        >
          {{ stage.title }}
        </span>
      </td>
      <td>
        {{stage.name}}
      </td>
      <td class="text-center">
        <p-badge
          [value]="stage.sortFloat + ''"
          severity="secondary"
        />
      </td>
      <td
        style="width: 2rem;"
        class="text-end"
      >
        <p-menu
          #menu
          appendTo="body"
          [model]="this.getStageMenuItems(stage._id)"
          [popup]="true"
        ></p-menu>

        <p-button
          [text]="true"
          [rounded]="true"
          [raised]="true"
          severity="secondary"
          icon="ri ri-more-2-fill"
          (onClick)="menu.toggle($event)"
        ></p-button>
      </td>
    </tr>
  </ng-template>
</p-table>
<app-bulk-action-bar
  [actions]="bulkActions"
  [count]="selectedStages.length"
  [busy]="bulkBusy"
  [allSelected]="selectedStages.length === this.stageAdmin.stages.length"
  (selectAll)="selectedStages = this.stageAdmin.stages.slice()"
  (clear)="selectedStages = []"
/>

@if (detailDrawer) {
<p-drawer
  [(visible)]="this.detailDrawer"
  appendTo="body"
  [position]="'right'"
  [modal]="true"
  [closeOnEscape]="true"
  styleClass="w-100 w-md-75 w-lg-50"
>
  @if (this.selectedStageId) {
  <app-stage-manager-detail
    [selectedStageId]="this.selectedStageId"
    (closeDrawer)="this.detailDrawer = false"
  ></app-stage-manager-detail>
  }
</p-drawer>
}